<jit-icon-simple *ngIf="icon" size="16" [iconId]="icon"></jit-icon-simple>

<span>{{ parse(duration || '') }}</span>
